import { Alert, Box, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/buttons/Buttons";
import { useAuth } from "../../auth/AuthContext";
import styles from "./Login.module.scss";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ userName: "", password: "" });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const loginTextFieldSx = {
    "& .MuiOutlinedInput-root": {
      minHeight: 48,
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 14px",
      lineHeight: 1.5,
    },
    "& .MuiInputLabel-root": {
      transform: "translate(14px, 13px) scale(1)",
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, -9px) scale(0.75)",
    },
  };

  const onChange = (key) => (event) => {
    setForm((prevForm) => ({
      ...prevForm,
      [key]: event.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!form.userName || !form.password) {
      setError("Username and password are required");
      return;
    }

    try {
      setIsSubmitting(true);
      await login(form.userName, form.password);
      navigate("/");
    } catch {
      setError("Invalid username or password");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      className={styles.loginPage}
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f8ff 0%, #eaf2ff 100%)",
        p: 2,
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        className={styles.loginForm}
        sx={{
          width: "100%",
          maxWidth: "420px",
          backgroundColor: "#fff",
          boxShadow: "0 12px 24px rgba(0, 58, 116, 0.12)",
          p: 4,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h5" fontWeight={600} className={styles.loginTitle}>
          KBS Login
        </Typography>
        {error ? <Alert severity="error">{error}</Alert> : null}
        <TextField
          label="Username"
          value={form.userName}
          onChange={onChange("userName")}
          fullWidth
          sx={loginTextFieldSx}
        />
        <TextField
          label="Password"
          value={form.password}
          onChange={onChange("password")}
          fullWidth
          type="password"
          sx={loginTextFieldSx}
        />
        <Button
          title={isSubmitting ? "Logging in..." : "Login"}
          buttonType="muibtn-primary"
          classList={styles.loginButton}
          withIcon={false}
          attriType="submit"
          isDisabled={isSubmitting}
        />
      </Box>
    </Box>
  );
}
